import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { WorkerProvider } from './context/workercontext/WorkerContext';
import { WorkerProfileProvider } from './context/workerprofilecontext/WorkerProfileContext';
import { BookingProvider } from './context/bookingcontext/BookingContext';
import { BookingDetailProvider } from './context/bookingdetailcontext/BookingDetailContext';
import { AppProvider } from './context/AppContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>

  <AppProvider>

        <BookingDetailProvider>
          <BookingProvider>

            <BrowserRouter>
              <WorkerProfileProvider>
                <WorkerProvider>
                  <App />
                </WorkerProvider>
              </WorkerProfileProvider>
            </BrowserRouter>

          </BookingProvider>
        </BookingDetailProvider>
</AppProvider>
   

  </React.StrictMode>
);

reportWebVitals();